import React, { Component, Fragment } from "react";
import { Button, Col, Form, Input, Label, FormGroup } from "reactstrap";
import * as customers from "customers/actions/customers";
import { connect } from "react-redux";
import { DetailContainer } from "customers/DetailContainer";
import autobind from "autobind-decorator";
import Loading from "apa/components/Loading";
import { BaseUrl } from "../BaseUrl/BaseUrl";
import { sendMessage } from "apa/actions";

@connect(
  (state) => {
    return {
      customers: state.customers,
      auth: state.apa,
    };
  },
  (dispatch) => {
    return {
      fetchCustomer: (customer_id, callback) => {
        dispatch(customers.fetchCustomer(customer_id, callback));
      },
      sendMessage: (message, type) =>
        dispatch(sendMessage({ text: message, color: type })),
    };
  }
)
class Rates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.rates,
    };
  }

  @autobind
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  @autobind
  onBlur(event) {
    event.preventDefault();
    const id = this.state.id;
    const headers = {
      Authorization: `Token ${this.props.auth.token}`,
      "Content-Type": "application/json",
    };
    const body = JSON.stringify(this.state);
    fetch(`${BaseUrl}/api/rates/${id}/`, { headers, method: "PATCH", body })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error ${res.status}`);
        }
        return res.json();
      })
      .then((rates) => {
        this.setState({
          ...rates,
        });
        this.props.sendMessage("Änderungen gespeichert.", "success");
      })
      .catch(() => this.props.sendMessage("Fehler aufgetreten.", "danger"));
  }

  render() {
    return (
      <Fragment>
        <FormGroup row>
          <Col className="d-flex align-items-center">
            <Label className="mb-0">Stundensatz - Regelbetreuung</Label>
          </Col>
          <Col>
            <Input
              onBlur={this.onBlur}
              type="number"
              step="0.01"
              value={this.state.default}
              name="default"
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col className="d-flex align-items-center">
            <Label className="mb-0">Stundensatz - Betriebsspezifisch</Label>
          </Col>
          <Col>
            <Input
              onBlur={this.onBlur}
              type="number"
              step="0.01"
              value={this.state.specific}
              name="specific"
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col className="d-flex align-items-center">
            <Label className="mb-0">Stundensatz - Fahrzeit</Label>
          </Col>
          <Col>
            <Input
              onBlur={this.onBlur}
              type="number"
              step="0.01"
              value={this.state.driving}
              name="driving"
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col className="d-flex align-items-center">
            <Label className="mb-0">Stundensatz - Sondereinsatz</Label>
          </Col>
          <Col>
            <Input
              onBlur={this.onBlur}
              type="number"
              step="0.01"
              value={this.state.extra}
              name={"extra"}
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col className="d-flex align-items-center">
            <Label className="mb-0">Stundensatz - Projekt</Label>
          </Col>
          <Col>
            <Input
              onBlur={this.onBlur}
              type="number"
              step="0.01"
              value={this.state.project}
              name={"project"}
              onChange={this.handleChange}
            />
          </Col>
        </FormGroup>
      </Fragment>
    );
  }
}

@connect(
  (state) => {
    return {
      customers: state.customers,
      auth: state.apa,
    };
  },
  (dispatch) => {
    return {
      fetchCustomer: (customer_id, callback) => {
        dispatch(customers.fetchCustomer(customer_id, callback));
      },
      sendMessage: (message, type) =>
        dispatch(sendMessage({ text: message, color: type })),
    };
  }
)
export default class NumberList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      isLoading: true,
      isEditing: false,
      showLadderTooltip: false,
      showShelfTooltip: false,
      customer: null,
    };
    this.initialCustomerState = null;
  }

  isEqualWithNullEmpty(obj1, obj2) {
    const normalize = (value) => (value === "" ? null : value);
    return Object.keys(obj1).every(
      (key) => normalize(obj1[key]) == normalize(obj2[key])
    );
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    this.props.fetchCustomer(id, (customer) => {
      this.setState({ isLoading: false, customer });
      this.initialCustomerState = { ...customer };
    });
  }

  @autobind
  handleChange(event) {
    const { name, type, value, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;
    this.setState((prevState) => {
      const updatedCustomer = { ...prevState.customer, [name]: newValue };
      const isEditing = !this.isEqualWithNullEmpty(
        updatedCustomer,
        this.initialCustomerState
      );
      return { customer: updatedCustomer, isEditing };
    });
  }

  @autobind
  onSubmit(event) {
    event.preventDefault();
    const id = this.props.match.params.id;
    const headers = {
      Authorization: `Token ${this.props.auth.token}`,
      "Content-Type": "application/json",
    };
    const customer = this.state.customer;
    delete customer.offer_file;
    delete customer.contract_file;
    const body = JSON.stringify(customer);
    this.setState({
      isSubmitting: true,
    });
    fetch(`${BaseUrl}/api/customers/${id}/`, { headers, method: "PATCH", body })
      .then((res) => res.json())
      .then((customer) => {
        this.initialCustomerState = { ...customer };
        this.setState({
          isSubmitting: false,
          isLoading: false,
          customer,
          isEditing: false,
        });
        this.props.sendMessage("Änderungen gespeichert.", "success");
      })
      .catch((error) => {
        this.props.sendMessage("Fehler aufgetreten.", "danger");
      });
  }

  @autobind
  handleDownloadIcs(checkupType) {
    const { id } = this.props.match.params;
    const headers = {
      Authorization: `Token ${this.props.auth.token}`,
      "Content-Type": "application/json",
    };

    fetch(`${BaseUrl}/api/customers/${id}/generate-ics?type=${checkupType}`, {
      method: "GET",
      headers,
    })
      .then((response) => {
        if (response.ok) {
          // Return the response as a Blob (binary data)
          return response.blob();
        } else {
          throw new Error("Failed to fetch .ics file");
        }
      })
      .then((data) => {
        // Create a link element to download the file
        const fileUrl = URL.createObjectURL(data);
        const a = document.createElement("a");
        a.href = fileUrl;
        let filename = "download";

        // Set the file name dynamically
        if (checkupType === "checkup_ladder") {
          filename = "leiterprüfung";
        } else if (checkupType === "checkup_shelf") {
          filename = "regalprüfung";
        }
        a.download = `${filename}_${id}_${this.state.customer.name}.ics`; // Custom name for the downloaded file
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(fileUrl); // Free up memory by revoking the object URL
      })
      .catch((error) => {
        console.error("Download failed:", error);
        this.props.sendMessage("Fehler beim Herunterladen.", "danger");
      });
  }

  render() {
    const id = this.props.match.params.id;
    const customer = this.state.customer;

    console.log(customer);

    if (this.state.isLoading) return <Loading />;
    return (
      <DetailContainer id={id}>
        <h1>{customer.name}</h1>
        <Form>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Regelbetreuung</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.target_hours}
                name="target_hours"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Berechnungsinterval</Label>
            </Col>
            <Col>
              <Input
                type="select"
                value={customer.payment_interval_type}
                name="payment_interval_type"
                onChange={this.handleChange}
              >
                <option value={1}>Jährlich</option>
                <option value={2}>Halbjährlich</option>
                <option value={4}>Quartal</option>
                <option value={12}>Monatlich</option>
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Beitrag - Interval</Label>
            </Col>
            <Col>
              <Input
                readOnly={true}
                type="number"
                step="0.01"
                value={customer.price}
                name="price"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Beitrag - Summe</Label>
            </Col>
            <Col>
              <Input
                readOnly={true}
                type="number"
                step="0.01"
                value={customer.price_gesamt}
                name="price_gesamt"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Betriebsspezifisch</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.betriebsspezifisch}
                name="betriebsspezifisch"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Bezahlungsanfang</Label>
            </Col>
            <Col>
              <Input
                value={customer.paymentstartdate}
                type="date"
                name="paymentstartdate"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Nach erbrachter Leistung</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.erbrachteleistung}
                name="erbrachteleistung"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Anfahrpauschale</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.anfahrt}
                name="anfahrt"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          {/* <FormGroup row>
                        <Col className='d-flex align-items-center'>
                            <Label className='mb-0'>
                                Kilometer
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number'
                                name='kilometer'
                                step='0.1'
                                value={customer.kilometer}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </FormGroup> */}
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Kilometerpauschale</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.kilometer_pauschale}
                name="kilometer_pauschale"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Hotelpauschale</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.hotel_allowence}
                name="hotel_allowence"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Materialpauschale Unterweisung / Ausbildung
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.instruction_material_cost}
                name="instruction_material_cost"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Betriebsanweisung digital zur Unterschrift
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.digital_instructions}
                name="digital_instructions"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Betriebsanweisung Papierausdruck</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.instructionmanual}
                name="instructionmanual"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">Betriebsanweisung Kopie</Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.instructionmanualcopy}
                name="instructionmanualcopy"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Flucht & Rettungsplan erstellen nach Vorlage zum Ausdruck (pro)
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.escape_n_rescue_plan}
                name="escape_n_rescue_plan"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>

          {/* <FormGroup row>
                        <Col>
                            <Label>
                                Schulung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instruction} name='instruction' onChange={this.handleChange} />
                        </Col>
                    </FormGroup> */}
          {/* <FormGroup row>
                        <Col>
                            <Label>
                                Unterweisungen
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.unterweisungen} name='unterweisungen' onChange={this.handleChange} />
                        </Col>
                    </FormGroup> */}
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Ausbildung Brandschutzhelfer Theorie pro Teilnehmer
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.ausbildungbrandschutz}
                name="ausbildungbrandschutz"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Ausbildung Brandschutzhelfer Praxis pro Teilnehmer
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.fire_safety_training_per_participant}
                name="fire_safety_training_per_participant"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Nachschulung Brandschutzhelfer Theorie pro Teilnehmer
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.fire_safety_ref_training_theory_per_participant}
                name="fire_safety_ref_training_theory_per_participant"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Jahresunterweisung - Arbeits-Brand-Gesunheitsschutz vor Ort
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.fire_health_protection_annual_training}
                name="fire_health_protection_annual_training"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Jahresunterweisung - Arbeits-Brand-Gesunheitsschutz DIGITAL
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.digital_fire_health_protection_annual_training}
                name="digital_fire_health_protection_annual_training"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                {
                  'Schulung "Leitende Angestellte" Verantwortung & Gesetzesgrundlagen'
                }
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.senior_employees_training}
                name="senior_employees_training"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Jahresunterweisung - Betriebsspezifisch erstellen
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.company_specific_annual_training}
                name="company_specific_annual_training"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          {/* <FormGroup row>
                        <Col>
                            <Label>
                                Jahresunterweisung - Brandschutz
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.instruction_yearly_fire_safety} name='instruction_yearly_fire_safety'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup> */}
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Jahresunterweisung - digitale Bereitstellung
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.annual_digital_training}
                name="annual_digital_training"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col className="d-flex align-items-center">
              <Label className="mb-0">
                Psychische Belastung - DIGITAL - Anlegen pro Gruppe
              </Label>
            </Col>
            <Col>
              <Input
                type="number"
                step="0.01"
                value={customer.digital_psychological_stress_setup_per_group}
                name="digital_psychological_stress_setup_per_group"
                onChange={this.handleChange}
              />
            </Col>
          </FormGroup>
          {/* <FormGroup row>
                        <Col>
                            <Label>
                                Leiterprüfung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.ladder_exam} name='ladder_exam'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup> */}
          {/* <FormGroup row>
                        <Col>
                            <Label>
                                Regalprüfung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.shelf_exam} name='shelf_exam'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup> */}
          {/* <FormGroup row>
                        <Col>
                            <Label>
                                Brandschutzunterweisung
                            </Label>
                        </Col>
                        <Col>
                            <Input
                                type='number' step='0.01'
                                value={customer.fire_protection_instruction} name='fire_protection_instruction'
                                onChange={this.handleChange} />
                        </Col>
                    </FormGroup> */}
          <Rates rates={this.state.customer.rates} />
          <div
            style={{
              border: "1px solid black",
              borderRadius: "8px",
              padding: "16px",
              paddingBottom: "0px",
              marginBottom: "16px",
            }}
          >
            <h5
              style={{
                textAlign: "center",
                marginBottom: "16px",
              }}
            >
              Prüfung - Leiter/Tritt
            </h5>
            <FormGroup row>
              <Col className="d-flex align-items-center">
                <Label className="mb-0">Datum</Label>
              </Col>
              <Col>
                <div className="d-flex align-items-center">
                  <Input
                    className="form-control"
                    type="date"
                    name="checkup_ladder"
                    value={customer.checkup_ladder}
                    onChange={this.handleChange}
                  />
                  <div
                    className="relative"
                    onMouseEnter={() =>
                      this.state.isEditing &&
                      this.setState({ showLadderTooltip: true })
                    }
                    onMouseLeave={() =>
                      this.setState({ showLadderTooltip: false })
                    }
                  >
                    <Button
                      className="ms-2"
                      style={{
                        backgroundColor: "#007bff",
                      }}
                      disabled={
                        !customer.checkup_ladder || this.state.isEditing
                      }
                      onClick={() => this.handleDownloadIcs("checkup_ladder")}
                    >
                      <i className="fa fa-download" />
                    </Button>
                    {this.state.showLadderTooltip && (
                      <div
                        className="popup"
                        style={{
                          position: "absolute",
                          bottom: "100%",
                          left: "50%",
                          transform: "translateX(-50%)",
                          padding: "10px",
                          backgroundColor: "black",
                          color: "white",
                          borderRadius: "5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Bitte stellen Sie sicher, dass alle Daten gespeichert
                        sind, bevor Sie die Datei herunterladen.
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col className="d-flex align-items-center">
                <Label className="mb-0">Erinnerungs-E-Mail aktivieren</Label>
              </Col>
              <Col>
                <Input
                  type="checkbox"
                  name="activate_checkup_ladder_reminder_email"
                  checked={customer.activate_checkup_ladder_reminder_email}
                  onChange={this.handleChange}
                  style={{
                    marginLeft: "1px",
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col className="d-flex align-items-center">
                <div className="d-flex justify-content-between w-100">
                  <Label className="mb-0">Intervall</Label>
                  <div className="d-flex align-items-center">
                    <span className="text-12 mr-1">Individuell</span>
                    <label class="toggle-switch">
                      <input
                        type="checkbox"
                        checked={this.state.customer.checkup_ladder_individual}
                        onChange={() =>
                          this.setState((prev) => ({
                            isEditing: true,
                            customer: {
                              ...prev.customer,
                              checkup_ladder_individual:
                                !prev.customer.checkup_ladder_individual,
                            },
                          }))
                        }
                      />
                      <div class="toggle-switch-background">
                        <div class="toggle-switch-handle"></div>
                      </div>
                    </label>
                  </div>
                </div>
              </Col>
              <Col>
                {this.state.customer.checkup_ladder_individual ? (
                  <Input
                    type="number"
                    step={1}
                    min={1}
                    value={this.state.customer.checkup_ladder_interval}
                    onKeyDown={(e) => {
                      if (e.key === ".") e.preventDefault();
                    }}
                    onChange={(e) => {
                      const interval = e?.target?.value;
                      this.setState((prev) => ({
                        isEditing: true,
                        customer: {
                          ...prev.customer,
                          checkup_ladder_interval: interval,
                        },
                      }));
                    }}
                  />
                ) : (
                  <select
                    className="form-control"
                    name="checkup_ladder_interval"
                    disabled={
                      !this.state.customer
                        .activate_checkup_ladder_reminder_email
                    }
                    value={
                      this.state.customer.activate_checkup_ladder_reminder_email
                        ? this.state.customer.checkup_ladder_interval
                        : ""
                    }
                    onChange={this.handleChange}
                  >
                    <option value="">-- Intervall wählen --</option>
                    <option value={6}>6 Monate</option>
                    <option value={12}>12 Monate</option>
                    <option value={24}>24 Monate</option>
                  </select>
                )}
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col>
                <Label className="mb-0">Ansprechpartner</Label>
              </Col>
              <Col>
                <select
                  className="form-control"
                  name="checkup_ladder_contact"
                  disabled={
                    !this.state.customer.activate_checkup_ladder_reminder_email
                  }
                  value={
                    this.state.customer.activate_checkup_ladder_reminder_email
                      ? this.state.customer.checkup_ladder_contact
                      : ""
                  }
                  onChange={this.handleChange}
                >
                  <option value="">-- Ansprechpartner auswählen --</option>
                  {this.state.customer.contacts.map((contact) => (
                    <option value={contact.id}>{contact.name}</option>
                  ))}
                </select>
              </Col>
            </FormGroup>
          </div>
          <div
            style={{
              border: "1px solid black",
              borderRadius: "8px",
              padding: "16px",
              paddingBottom: "0px",
              marginBottom: "16px",
            }}
          >
            <h5
              style={{
                textAlign: "center",
                marginBottom: "16px",
              }}
            >
              Prüfung - Regal
            </h5>
            <FormGroup row>
              <Col className="d-flex align-items-center">
                <Label className="mb-0">Datum</Label>
              </Col>
              <Col>
                <div className="d-flex align-items-center">
                  <Input
                    className="form-control"
                    type="date"
                    name="checkup_shelf"
                    value={customer.checkup_shelf}
                    onChange={this.handleChange}
                  />
                  <div
                    className="relative"
                    onMouseEnter={() =>
                      this.state.isEditing &&
                      this.setState({ showShelfTooltip: true })
                    }
                    onMouseLeave={() =>
                      this.setState({ showShelfTooltip: false })
                    }
                  >
                    <Button
                      className="ms-2"
                      style={{
                        backgroundColor: "#007bff",
                      }}
                      disabled={!customer.checkup_shelf || this.state.isEditing}
                      onClick={() => this.handleDownloadIcs("checkup_shelf")}
                    >
                      <i className="fa fa-download" />
                    </Button>
                    {this.state.showShelfTooltip && (
                      <div
                        className="popup"
                        style={{
                          position: "absolute",
                          bottom: "100%",
                          left: "50%",
                          transform: "translateX(-50%)",
                          padding: "10px",
                          backgroundColor: "black",
                          color: "white",
                          borderRadius: "5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Bitte stellen Sie sicher, dass alle Daten gespeichert
                        sind, bevor Sie die Datei herunterladen.
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col>
                <Label className="mb-0">Erinnerungs-E-Mail aktivieren</Label>
              </Col>
              <Col>
                <Input
                  type="checkbox"
                  name="activate_checkup_shelf_reminder_email"
                  checked={customer.activate_checkup_shelf_reminder_email}
                  onChange={this.handleChange}
                  style={{
                    marginLeft: "1px",
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col className="d-flex align-items-center">
                <div className="d-flex justify-content-between w-100">
                  <Label className="mb-0">Intervall</Label>
                  <div className="d-flex align-items-center">
                    <span className="text-12 mr-1">Individuell</span>
                    <label class="toggle-switch">
                      <input
                        type="checkbox"
                        checked={this.state.customer.checkup_shelf_individual}
                        onChange={() =>
                          this.setState((prev) => ({
                            isEditing: true,
                            customer: {
                              ...prev.customer,
                              checkup_shelf_individual:
                                !prev.customer.checkup_shelf_individual,
                            },
                          }))
                        }
                      />
                      <div class="toggle-switch-background">
                        <div class="toggle-switch-handle"></div>
                      </div>
                    </label>
                  </div>
                </div>
              </Col>
              <Col>
                {this.state.customer.checkup_shelf_individual ? (
                  <Input
                    type="number"
                    step={1}
                    min={1}
                    value={this.state.customer.checkup_shelf_interval}
                    onKeyDown={(e) => {
                      if (e.key === ".") e.preventDefault();
                    }}
                    onChange={(e) => {
                      const interval = e?.target?.value;
                      this.setState((prev) => ({
                        isEditing: true,
                        customer: {
                          ...prev.customer,
                          checkup_shelf_interval: interval,
                        },
                      }));
                    }}
                  />
                ) : (
                  <select
                    className="form-control"
                    name="checkup_shelf_interval"
                    disabled={
                      !this.state.customer.activate_checkup_shelf_reminder_email
                    }
                    value={
                      this.state.customer.activate_checkup_shelf_reminder_email
                        ? this.state.customer.checkup_shelf_interval
                        : ""
                    }
                    onChange={this.handleChange}
                  >
                    <option value="">-- Intervall wählen --</option>
                    <option value={6}>6 Monate</option>
                    <option value={12}>12 Monate</option>
                    <option value={24}>24 Monate</option>
                  </select>
                )}
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col>
                <Label className="mb-0">Ansprechpartner</Label>
              </Col>
              <Col>
                <select
                  className="form-control"
                  name="checkup_shelf_contact"
                  disabled={
                    !this.state.customer.activate_checkup_shelf_reminder_email
                  }
                  value={
                    this.state.customer.activate_checkup_shelf_reminder_email
                      ? this.state.customer.checkup_shelf_contact
                      : ""
                  }
                  onChange={this.handleChange}
                >
                  <option value="">-- Ansprechpartner auswählen --</option>
                  {this.state.customer.contacts.map((contact) => (
                    <option value={contact.id}>{contact.name}</option>
                  ))}
                </select>
              </Col>
            </FormGroup>
          </div>
          <FormGroup>
            <Button
              onClick={this.onSubmit}
              color={this.state.isEditing ? "primary" : "success"}
              disabled={this.state.isSubmitting || !this.state.isEditing}
            >
              Speichern
            </Button>
          </FormGroup>
        </Form>
      </DetailContainer>
    );
  }
}
